import { DAC_TROUBLESHOOTING_DOC_LINK } from '@/constants';
import { SLO } from '@/ui';
import {
  LogItemSeverity,
  SeverityLevel,
} from '@/components/composed/slo-card/graph/fault-zone/log-item';

export interface SLOGraphWarning {
  title: string;
  message: string;
  severity: SeverityLevel;
  docLink: string;
}

export function evaluateWarnings(indicator: SLO['indicator']): SLOGraphWarning[] {
  const warnings: SLOGraphWarning[] = [];

  if (indicator?.lowResolution) {
    warnings.push({
      title: 'Low resolution SLI',
      message: `The duration of your SLI’s data points is not one minute. This means that burn
      events cannot be calculated and will not display on your Daily SLI graph`,
      severity: LogItemSeverity.WARNING,
      docLink: `${DAC_TROUBLESHOOTING_DOC_LINK}#low-resolution-sli`,
    });
  }

  return warnings;
}
